<script>
    import { _ } from 'svelte-i18n';
    import axios from 'axios';
    import { url } from '../stores/url.js';
    import { roles } from '../stores/roles.js'; 
    import { users } from '../stores/users.js'; 
    import { permissions } from '../stores/permissions.js'; 
    import { swalConfirm } from '../functions/html-helpers.js';
    import { request  } from '../functions/http-helpers.js'

</script>



<div class="uk-container">
    <div class="uk-card uk-card-default uk-card-body uk-margin-top">
        <h3>{$_('settings')}</h3>

        <div uk-grid>
            <div class="uk-width-1-1">
                <p>SMTP E-Mail</p>
            </div>
        </div>
    </div>
</div>